import { styled } from '@stitches/react';
import { useMemo } from 'react';
import { useElements, useScene } from '../../hooks';

export const ImgElement = ({ elementID }: { elementID: string }) => {
  const scene = useScene();
  const [element] = useElements({ id: elementID });

  const Img = useMemo(
    () => styled('img', element?.props?.class as {}),
    [element?.props?.class]
  );

  return (
    <Img
      element-type="img"
      id={element?.id}
      {...scene.launcherStateProps}
      src={element?.props?.src}
      onDragStart={(e) => e.preventDefault()}
    />
  );
};
